import type { User, UserSso } from '../services/AuthService/types';

export function mapUserToState(apiUser: UserSso, partnerId: string): User {
  const linkedPartner = apiUser.linkedPartners.find((p: any) => p.partnerId === partnerId);

  const { email, givenName, surname, userId, active } = apiUser;

  return {
    email,
    givenName,
    sessionPartnerRole: linkedPartner?.role || undefined,
    surname,
    userId,
    active,
  };
}
